import { getApiUrl } from './apiUrls';
import HTTPGetClient from './HTTPClient';

export const API = new HTTPGetClient({ baseUrl: getApiUrl(2) });
export const API_MOCK = new HTTPGetClient({ baseUrl: 'http://localhost:3000/oversluitentool/assets/json/' });
